import { render } from "./administracao.vue?vue&type=template&id=2081c078"
import script from "./administracao.vue?vue&type=script&lang=js"
export * from "./administracao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__